


























































































import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({})
export default class Notifications extends Vue {
  open = false;

  toggle() {
    this.open = !this.open;
  }

  /* Close element on click outside */
  documentClick(event: any) {
    const el = this.$refs.notificationMenuComponent as HTMLElement;
    if (!el.contains(event.target) && this.open) {
      this.toggle();
    }
  }
  created() {
    document.addEventListener("click", this.documentClick);
  }
  destroyed() {
    document.removeEventListener("click", this.documentClick);
  }
}
